// header.component.ts
import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, EventEmitter, OnInit, Output, ViewChild,HostListener } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, Subject, Subscription } from 'rxjs';
import { debounceTime, map, startWith, switchMap, takeUntil } from 'rxjs/operators';
import { DataService } from 'src/app/pages/data.service';
import { urls } from 'src/app/pages/urls';
import { MatMenu, MatMenuTrigger } from '@angular/material/menu';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})



export class HeaderComponent {
  @Output() filterChange = new EventEmitter<string>();
  @Output() brandFilterChange: EventEmitter<any[]> = new EventEmitter<any[]>();
  @Output() openFilterChange = new EventEmitter<string>();
  @Output() headerFiter: EventEmitter<any> = new EventEmitter<any>();
  // private viewProductResponseSubscription: Subscription;
  private destroy$: Subject<void> = new Subject<void>(); // Subject to handle subscription cleanup

  requestOpen = {}
  categoryCtrl = new FormControl();
  brandCtrl = new FormControl();
  enCtrl = new FormControl();
  categoryAuto: any;
  openAuto: any;
  searchControl = new FormControl();
  categories: any[] = [];
  username: string
  countryName: string
  parentBusinessName : string
  brandIDs: any[];
  viewProductResponse: any;
  viewEnabledFilter: string = ""
  @ViewChild('search') searchTextBox: ElementRef;


  searchTextboxControl = new FormControl();
  selectedValues: any[] = [];
  data: any[] = []; // Will be populated from the API response

  filteredOptions: Observable<any[]>;


  searchOpenControl = new FormControl();


  searchOpenString: string = '';
  searchCategoryID: any;

  sor:string="";
  searchBrandID: any[];
  searchString: string = '';
  brandsselectAll = false;



  filteredCategories: any[];
  searchBrandControl = new FormControl();
  filteredBrands: any[] = [];
  selectedBrands: any[] = [];
  selectedBrandOptions: any[] = [];
  brandFilterControl: FormControl = new FormControl();
  brandList: any[] = [];
  brandListData:any[]=[];
  imgPrefix= urls.s3Link;
  @ViewChild('brandAuto') brandAuto: ElementRef;

  panelColor = new FormControl('All');
  myControl = new FormControl();
  //options: string[] = ['Socket head cap screws', 'Fastners/screws & bolts', 'Fastners', 'Bolts'];
  ispopUpShow: boolean = true;

  @ViewChild('myMenu') myMenu: ElementRef;

  @ViewChild('categoryMenu') categoryMenu;
  searchedData: any;
  currentRoute: string = '';
  constructor(private dataService: DataService, private http: HttpClient, private service: DataService, private router: Router, private paramRoute: ActivatedRoute,private elementRef: ElementRef) {

  }

  async ngOnInit() {

    this.username = this.service.getEmail().split(".")[0].toUpperCase();
    this.countryName = localStorage.getItem('selectedCountryName');
    this.parentBusinessName= this.service.getSelectedBusinessDisplayName();
    this.setupAutocomplete();
    this.setupAutoBrandcomplete();
    this.setupAutoOpencomplete();
    // this.filteredOptions = this.myControl.valueChanges.pipe(
    //   startWith(''),
    //   map(value => this._filter(value))
    // );
    this.currentRoute = this.router.url;
    const urlWithoutParams = this.router?.url.split('?')[0];
    if (urlWithoutParams == "/product-discovery") {
      this.paramRoute.queryParams.subscribe(params => {
        this.searchCategoryID = params['category'];
        this.searchOpenString = params['searchStr'] == undefined ? '' : params['searchStr'];
        if (params['brandIds'])
          this.brandIDs = Array.isArray(params['brandIds']) ? params['brandIds'] : [params['brandIds']];

        this.searchOpenControl.setValue(this.searchOpenString);

        this.sor = params['sor'];
      });

      await this.onSearchFilterChange('');

      this.searchControl.setValue(this.getSelectedCategoryName(this.searchCategoryID));
      this.selectedBrands = this.getFilteredBrands(this.brandIDs);
    }
    // this.getSelectedBrands(false);
  }
  getFilteredBrands(brandIDs: any): any[] {
    brandIDs.forEach(brandId => {
      const brand = this.searchedData?.filteredBrandInfo[brandId];
      let data = {
        'brandName': brand?.brandName,
        'brandId': brandId
      }
      this.selectedBrands.push(data);
    })
    return this.selectedBrands;
  }
  // private _filter(value: string): string[] {
  //   const filterValue = value.toLowerCase();

  //   return this.options.filter(option => option.toLowerCase().indexOf(filterValue) === 0);
  // }
  setupAutocomplete() {
    this.searchControl.valueChanges.pipe(
      debounceTime(300),
      switchMap(value => {
        if (value && value.length >= 2) {
          return this.fetchCategories(value);
        } else {
          this.searchCategoryID = ''
          return [];
        }
      })
    ).subscribe((categories: any[]) => {
      this.filteredCategories = categories;
    });
  }

  fetchCategories(searchQuery: string) {
    const apiUrl = urls.platformdatprod + `cassandraFeed/catalogCategory/categorySearch`;
    const countryCode = this.dataService.getSelectedCountryCode();
    const parentBusinessCode = this.dataService.getSelectedParentBusinessCode();
    const request = { searchQuery, countryCode, parentBusinessCode };
    return this.http.post(apiUrl, request).pipe(
      map((response: any) => {
        const data = response && response.data ? response.data : {};
        return Object.entries(data).map(([key, value]) => ({ categoryCode: key, categoryName: value }));
      })
    );
  }

  onCategoryFilterChange(categoryFilterValue: any) {
    this.searchControl.setValue(categoryFilterValue.categoryName);
    this.searchCategoryID = categoryFilterValue.categoryCode;
    //localStorage.setItem('page1slectedCategory', this.searchCategoryID);
    this.filterChange.emit(categoryFilterValue.categoryCode);
  }


  // Handle brand selection changes
  setupAutoBrandcomplete() {
    this.searchBrandControl.valueChanges.pipe(
      debounceTime(300),
      switchMap(value => {
        if (value && value.length >= 2) {
          return this.fetchBrands(value);
        } else {
          return []; // Return an empty array if the value is empty or less than 3 characters
        }
      })
    ).subscribe((brands: any[]) => {

      this.filteredBrands = brands;
    });
  }

  fetchBrands(brandSearch: string): Observable<any[]> {
    // const apiUrl = urls.search + 'search/brands'
    const apiUrl = 'https://catalogsearch.moglix.com/search/brands'
    const requestBrand = {
      searchString: [brandSearch],
      havingPdf: false,
      havingLatestPdf: false,
      countryCode: this.dataService.getSelectedCountryCode()
    };

    return this.http.post(apiUrl, requestBrand).pipe(
      map((response1: any) => {
        const data1 = response1 && response1.data ? response1.data : {};
        let keystr = Object.keys(data1['brandSearchResponse'])
        this.brandList = data1['brandSearchResponse'][keystr[0]];

        // Add the 'checked' property to each brand item
        this.brandList.forEach(brand => brand.checked = false);

        return this.brandList;
      })
    );
  }

  // Display brand name in the autocomplete input field
  displayBrandName(brand: any): string {
    return brand && brand.brandName ? brand.brandName : '';
  }



  // getSelectedBrandNames(): string {
  //   return this.selectedBrands.map(brand => brand.brandName).join(', ');

  // }



  onBrandSelectionChange(brand: any) {

    const index = this.selectedBrands.findIndex(b => b.brandId === brand.brandId);
    if (index === -1) {
      this.selectedBrands.push(brand);
    } else {
      this.selectedBrands.splice(index, 1);
    }


    // brand.checked = isChecked;

    this.brandIDs = this.selectedBrands.map(selectedBrand => selectedBrand.brandId) as any[];

    this.getSelectedBrands(true)
    // Emit the selected brand(s) to the header component
    this.brandFilterChange.emit(this.selectedBrands);

  }


  // selectAllBrands() {
  //   this.selectedBrands = [...this.filteredBrands];
  //   this.selectedBrands.forEach(brand => brand.checked = true);
  // }
  // Clear all selected brands
  // clearAllSelections($event) {
  //   this.selectedBrands = [];
  //   this.filteredBrands.forEach(brand => brand.checked = false);
  // }


  // Check if a brand is selected or not
  // isSelected(brand: any): boolean {
  //   return this.selectedBrands.some((selectedBrand) => selectedBrand.brandId === brand.brandId);
  // }
  onInputFocus(event: FocusEvent) {
    if (this.searchBrandControl.value) {
      const matAutocompleteTrigger = this.brandAuto.nativeElement as HTMLElement;
      matAutocompleteTrigger.click();
    }
  }

  setupAutoOpencomplete() {
    this.searchOpenControl.valueChanges
      .subscribe((openString: string) => {
        this.searchOpenString = openString;
      });
  }

  onOpenFilterChange(openFilterValue: string) {
    this.searchOpenControl.setValue(openFilterValue);
    this.searchOpenString = openFilterValue;
    // Emit the value to the parent component
    this.openFilterChange.emit(openFilterValue);
  }


  // Function to clear the selected brands and reset the filtered brands list
  clearSelection() {
    this.selectedBrands.forEach(brand => brand.checked = false);
    this.selectedBrands = [];
    this.filteredBrands = [];
  }
  logout() {
    this.service.destorySession();
    this.router.navigateByUrl('/login')
      .then(() => {
        window.localStorage.setItem('logged_in', 'false');

      });
  }
  async onSearchFilterChange(searchID: string) {

    if (!this.searchCategoryID && !this.brandIDs && !this.searchOpenString) {
      this.dataService.showMessage("info", "No Search query identified !!")
      return
    }
    this.requestOpen = {
      "productSearchString": this.searchOpenString || "",
      "categoryCode": this.searchCategoryID || "",
      "brandIds": this.brandIDs || [],
      "viewEnabledFilter": false,
      "viewHeaderRequired": true,
      "viewFilterRequired": true,
      "countryName": this.dataService.getSelectedCountryName().toLowerCase(),
      "businessCode": this.dataService.getSelectedParentBusinessCode()
    };
    let pageNo = 0
    let pageSize = 20
    const url = urls.search + `search/view/products?pageNo=${pageNo}&pageSize=${pageSize}`;

    localStorage.setItem('request', JSON.stringify(this.requestOpen));
    // if (this.searchCategoryID)
    //   localStorage.setItem('page1slectedCategory', this.searchCategoryID);
    // else {
    //   localStorage.removeItem('page1slectedCategory');
    // }

    // if (this.brandIDs) {
    //   localStorage.setItem('page1slectedbrandIds', this.brandIDs);
    // }
    // else {
    //   localStorage.removeItem('page1slectedbrandIds');
    // }
    // if (this.searchOpenString)
    //   localStorage.setItem('page1slectedopenString', this.searchOpenString);
    // else {
    //   localStorage.removeItem('page1slectedopenString');
    // }


    const data = await this.dataService.getProductViewAPI(url, this.requestOpen)
      .pipe(takeUntil(this.destroy$))
      .toPromise();


    // this.dataService.getProductViewAPI(url, this.requestOpen).pipe(takeUntil(this.destroy$)).subscribe(data => {
    if (data['status'] && data.data.products.length != 0) {
      this.searchedData = data.data;
      this.dataService.emitSearchFilterChange(data);

      const queryParams: any = {};

      if (this.searchCategoryID) {
        queryParams.category = this.searchCategoryID;
      }


      if (this.searchOpenString) {
        queryParams.searchStr = this.searchOpenString;
      }
      if (this.brandIDs && this.brandIDs.length > 0) {

        queryParams.brandIds = this.brandIDs;



      }
      queryParams.sor=this.sor?this.sor:"CIS";


      this.router.navigate(['./product-discovery'], { queryParams });

      // const urlWithParams = this.router.createUrlTree(['/product-discovery'], { queryParams }).toString();
      // this.router.navigateByUrl(urlWithParams);

    } else {
      this.requestOpen = {};
      this.dataService.offSpinner()
      this.router.navigateByUrl('/no-result-found');

    }
    // });
  }

  refresh() {
    // localStorage.removeItem('page1slectedopenString');
    // localStorage.removeItem('page1slectedCategory');
    // localStorage.removeItem('page1slectedbrandIds');


    this.searchOpenString = null
    this.brandIDs = null
    this.searchCategoryID = null;
    this.filteredBrands = null;
    this.selectedBrands = [];
    this.viewEnabledFilter = ""

  }
  ngOnDestroy() {

    this.destroy$.next();
    this.destroy$.complete();
  }

  goBack() {
    // localStorage.removeItem('page1slectedopenString');
    // localStorage.removeItem('page1slectedCategory');
    // localStorage.removeItem('page1slectedbrandIds');
    this.searchOpenString = null
    this.brandIDs = null
    this.searchCategoryID = null;
    this.filteredBrands = null;
    this.selectedBrands = [];
    this.viewEnabledFilter = ""
    this.searchControl.setValue("");
    this.router.navigateByUrl('/category-discovery');

  }


  clearSelectedBrands() {
    this.selectedBrands = [];
    this.viewEnabledFilter = ''
    this.brandIDs = [];
    // localStorage.removeItem('page1slectedbrandIds');
  }

  deleteSelectedCat(selectedCategory: any, index: number) {

    // Remove the category from the selectedBrands array
    this.selectedBrands.splice(index, 1);
    // this.brandIDs.splice(index, 1);

    this.brandIDs = this.selectedBrands.map(selectedBrand => selectedBrand.brandId) as any[];


    // Update the selectedOptions array
    // this.selectedBrands = this.selectedBrands.filter(
    //   (option) => option !== selectedCategory
    // );

  }



  onBrandFiltercatChange(event: any) {
    // Handle changes in the brand filter selection
    this.selectedBrandOptions = this.brandFilterControl.value;
  }

  getSelectedBrands(isTrue: boolean): string {


    if (isTrue) {

      if (this.selectedBrands != undefined && this.selectedBrands?.length != 0) {
        this.viewEnabledFilter = this.selectedBrands[0].brandName
        let NoOfChar = this.viewEnabledFilter.length
        if (NoOfChar >= 8) {
          length = this.selectedBrands.length - 1
          this.viewEnabledFilter = this.viewEnabledFilter.substring(0, 8) + "...+" + length + "more"
        }
        if (this.selectedBrands.length != 1 && NoOfChar < 8) {
          this.viewEnabledFilter += "," + this.selectedBrands[1].brandName
          if (this.selectedBrands.length != 2) {
            length = this.selectedBrands.length - 2
            this.viewEnabledFilter += "...+" + length + "more"
          }
        }
      } else
        this.viewEnabledFilter = ''

      return this.viewEnabledFilter
    }
    else {
      this.viewEnabledFilter = this.searchOpenString
      return this.viewEnabledFilter
    }
  }


  preventMenu(menuTrigger: MatMenuTrigger) {
    menuTrigger.closeMenu();
  }


  handleSpaceKey(event: KeyboardEvent, menuTrigger: MatMenuTrigger) {

    if (event.key === 'Enter') {
      event.stopPropagation();
      // this.preventMenu(menuTrigger);
      this.onSearchFilterChange('Enter');

    }
  }


  getCountryFlag(country: string) {
    return "assets/img/" + country + ".svg";
  }


  focusMenuBrand() {
    setTimeout(() => {
      this.myMenu.nativeElement.focus();
    }, 800)
  }
  getSelectedCategoryName(searchCategoryID: any): any {

    if (searchCategoryID === this.searchedData?.filteredCategoryInfo?.categoryCode)
      return this.searchedData?.filteredCategoryInfo?.categoryName;

  }
  isDropdownOpen = false;
  toggleDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen;
    this.fetchBrandList();
  }
  @HostListener('document:click', ['$event'])
  onClickOutside(event: Event) {
    const clickedInside = this.elementRef.nativeElement.contains(event.target);
    if (!clickedInside) {
      this.isDropdownOpen = false;
    }
  }

  fetchBrandList(){
    let url = urls.platformdatprod+"cassandraFeed/utility/getBrandIdWithFlag?flag=true";

    this.dataService.callRestful('GET',url,null,null,null,null).subscribe(response=>{
      if(response.status && response.data){
        this.brandListData=response.data;
        console.log(this.brandList)
        this.dataService.offSpinner();
      }else{
        this.dataService.offSpinner();
      }
    })
  }

  capitalizeFirstLetterOfEachWord(input: string): string {
    // Split the string into words
    const words = input.split(' ');

    // Capitalize the first letter of each word
    const capitalizedWords = words.map(word =>
      word.charAt(0).toUpperCase() + word.slice(1)
    );

    // Join the capitalized words back into a single string
    return capitalizedWords.join(' ');
  }

  navigateToBrandPage(brandId,brandName){
    console.log('click event called');
    this.dataService.setSelectedBrandId(brandId);
    this.dataService.setSelectedBrandName(brandName);
    window.open('/company-product-group?brand='+brandId+'&brandName='+brandName);
  }
}


